import { pushNotificationReceive as pushNotificationReceiveAction } from 'containers/App/actions';

class Push {

    constructor() {
        // the registration id and type
        this.pushToken = undefined;
    }

    /**
     * Initializes the Firebase service.
     */
    init(dispatch) { // eslint-disable-line no-unused-vars
        document.addEventListener('deviceready', () => {
            try {
                const FirebasePlugin = Push.getPlugin();

                Push.initializeFirebase()
                    .then(() => this.initializePushToken())
                    .then(() => {
                        FirebasePlugin.onNotificationOpen(
                            result => {
                                console.log(`Push: notification received: ${JSON.stringify(result)}`);
                                dispatch(pushNotificationReceiveAction(result));
                                FirebasePlugin.clearAllNotifications();
                            },
                            err => {
                                console.log(`Push: Error receiving push notification: ${err}`);
                            }
                        );

                        console.log('Push: service initialized');
                    })
                    .catch(err => {
                        console.log(`Push: Error get push token from FirebasePlugin: ${err}`);
                    });
            } catch (err) {
                console.log(`Push: Error initializing service: ${err}`);
            }
        });
    }

    /**
     * Get the Cordova FirebasePlugin object.
     * @returns {null|Object}
     */
    static getPlugin() {
        const { cordova, FirebasePlugin } = window;
        if (cordova
            && (cordova.platformId === 'ios' || cordova.platformId === 'android')
            && FirebasePlugin) {
            return FirebasePlugin;
        } else {
            throw Error(`FirebasePlugin for platform ${cordova.platformId} not available`);
        }
    }

    /**
     * Initializes the Push token.
     * @returns {Promise}
     */
    initializePushToken() {
        const { cordova } = window;

        if (cordova.platformId === 'ios') {
            return Push
                .hasPermission()
                .then(data => {
                    if (!data.isEnabled) {
                        return Push
                            .grantPermission()
                            .then(() => this.getToken());
                    } else {
                        return this.getToken();
                    }
                });
        } else {
            return this.getToken();
        }
    }

    /**
     * Promisify FirebasePlugin.initFirebase().
     * @return {Promise<any>}
     */
    static initializeFirebase() {
        return new Promise((resolve, reject) => {
            try {
                const FirebasePlugin = Push.getPlugin();
                FirebasePlugin.initFirebase(
                    result => resolve(result),
                    error => reject(error),
                );
            } catch (err) {
                reject(err);
            }
        });
    }

    /**
     * Promisify FirebasePlugin.hasPermission().
     * @return {Promise<any>}
     */
    static hasPermission() {
        return new Promise((resolve, reject) => {
            try {
                const FirebasePlugin = Push.getPlugin();
                FirebasePlugin.hasPermission(
                    result => resolve(result),
                    error => reject(error),
                );
            } catch (err) {
                reject(err);
            }
        });
    }

    /**
     * Promisify FirebasePlugin.grantPermission().
     * @return {Promise<any>}
     */
    static grantPermission() {
        return new Promise((resolve, reject) => {
            try {
                const FirebasePlugin = Push.getPlugin();
                FirebasePlugin.grantPermission(
                    result => resolve(result),
                    error => reject(error),
                );
            } catch (err) {
                reject(err);
            }
        });
    }

    /**
     * Promisify FirebasePlugin.getToken().
     * @return {Promise<any>}
     */
    getToken() {
        return new Promise((resolve, reject) => {
            try {
                const FirebasePlugin = Push.getPlugin();
                FirebasePlugin.onTokenRefresh(
                    result => {
                        console.log(`Push: push token received: ${result.substring(0, 15)}…`);
                        this.pushToken = result;
                        resolve();
                    },
                    error => reject(error),
                );
            } catch (err) {
                reject(err);
            }
        });
    }

    /**
     * Get the Push token of this device.
     * @return {String} The Push token if available.
     */
    getPushToken() {
        return this.pushToken;
    }

}

export default new Push();
